import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

/* 🔇 GLOBAL CONSOLE SILENCER (PROD ONLY) */
//if (process.env.NODE_ENV === 'production') {
//console.log = () => {};
//console.debug = () => {};
//}


axios.defaults.baseURL = process.env.VUE_APP_API_BASE || window.location.origin;

// Attach access token to every request
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let pendingRequests = [];

function processQueue(error, token = null) {
  pendingRequests.forEach(p => (error ? p.reject(error) : p.resolve(token)));
  pendingRequests = [];
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const backendMsg = error.response?.data?.error;
    const originalRequest = error.config;

    // Handle 403 (no permission)
    if (status === 403) {
      alert(backendMsg || 'You do not have permission to perform this action.');
      return Promise.reject(error);
    }

    // Handle 401 (expired/invalid access token) with refresh + retry
    if (status === 401) {
      // avoid infinite loops
      if (originalRequest?._retry) return Promise.reject(error);
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        // nothing to refresh with -> force login
        return Promise.reject(error);
      }

      // queue requests while refresh in progress
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingRequests.push({
            resolve: (token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axios(originalRequest));
            },
            reject
          });
        });
      }

      isRefreshing = true;

      try {
        const res = await axios.post('/auth/refresh', { refresh_token: refreshToken });

        const newAccess = res.data.access_token;
        const newRefresh = res.data.refresh_token;

        localStorage.setItem('access_token', newAccess);
        localStorage.setItem('refresh_token', newRefresh);

        processQueue(null, newAccess);

        originalRequest.headers.Authorization = `Bearer ${newAccess}`;
        return axios(originalRequest);
      } catch (refreshErr) {
        processQueue(refreshErr, null);

        // optional but recommended: nuke tokens + send to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        // router.push('/login'); // if you have a login route

        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    // anything else
    return Promise.reject(error);
  }
);

// Boot app
const app = createApp(App);
app.use(router);
app.config.globalProperties.$axios = axios;
app.mount('#app');
